import Roles from '@/utils/roles';
import { isInRoles } from '@/utils/authorize.directive';

export default [
  {
    path: '/pre-cadastro',
    name: 'pre-cadastro',
    meta: {
      title: 'Pré Cadastro',
      authRequired: true,
      roles: [Roles.CommercialPreRegistration]
    },
    // A checagem genérica de meta.roles segue comentada no router/index.js.
    beforeEnter: (to, from, next) => {
      if (!isInRoles(Roles.CommercialPreRegistration)) {
        next({ name: 'home' });
        return;
      }
      next();
    },
    component: () => import('@/views/area-mention/pre-cadastro/index.vue')
  }
];
